import { Query } from "@datorama/akita";

import TikTokGalleryStore, {
    TikTokGalleryState,
} from "../stores/TikTokGalleryStore";

class TikTokGalleryQuery extends Query<TikTokGalleryState> {
    constructor(protected store: TikTokGalleryStore) {
        super(store);
    }

    gallery$ = this.select((v) => v.gallery);
    getGalleryError$ = this.selectError();
}

export default TikTokGalleryQuery;
